import React, { useEffect, useState, useCallback, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid

import { DeptSelector, DeptStorage } from "../../components";

import "./bodyContainer.css";

const BodyContainer = () => {
  const gridRef = useRef();
  const [dept, setDept] = useState([]);
  const [selectedDept, setSelectedDept] = useState("All Course Codes");
  const [deptStorageDetails, setDeptStorageDetails] = useState([]);

  useEffect(() => {
    // fetch("../../course-storage/api/v1/dept-list.php")
      fetch(`https://bb-coprod-2.uic.edu/course-storage/api/v1/dept-list.php`)
      .then((response) => response.json())
      .then((usefulData) => {
        setDept(usefulData);
      });
  }, []);

  useEffect(() => {
    if (selectedDept !== "All Course Codes") {
        fetch(
          `https://bb-coprod-2.cc.uic.edu/course-storage/api/v1/storage-by-dept.php?dept=${selectedDept}`
        )
      // fetch(
      //   `../../course-storage/api/v1/storage-by-dept.php?dept=${selectedDept}`
      // )
        .then((response) => response.json())
        .then((usefulData) => {
          setDeptStorageDetails(usefulData);
        });
    }
  }, [selectedDept]);

  //
  const numberFormatter = (params) => {
    let value =
      Math.round((Number(params.value) + Number.EPSILON) * 100) / 100 / 1024;
    let formatted = value
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return formatted + " GB";
  };

  const autoSizeStrategy = {
    type: "fitGridWidth",
    defaultMinWidth: 100,
    columnLimits: [
      {
        colId: "country",
        minWidth: 900,
      },
    ],
  };

  const [colDefs] = useState([
    {
      field: "Course_Code",
      filter: true,
      headerName: "Course Code",
      // suppressSizeToFit: false,
      // defaultMinWidth: 150,
      // width: 200,
      valueFormatter: (params) => {
        return params.value.toUpperCase();
      },
    },
    {
      field: "Size",
      comparator: (valueA, valueB, nodeA, nodeB) => valueA - valueB,
      valueFormatter: numberFormatter,
    },
  ]);

  const onQuickFilterChanged = useCallback(() => {
    gridRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("quickFilter").value
    );
  }, []);

  const onSelectionChanged = useCallback(() => {
    const selectedRows = gridRef.current.api.getSelectedRows();
    setSelectedDept(selectedRows[0].Course_Code);
  }, []);

  return (
    <div className="container">
      <div className="Heading">
        <h1>Storage by Course Code</h1>
      </div>
      <div className="dropdown-container">
        <DeptSelector
          dept={dept}
          setDept={setDept}
          selectedDept={selectedDept}
          setSelectedDept={setSelectedDept}
        />
      </div>
      {selectedDept !== "All Course Codes" && deptStorageDetails.length > 0 && (
        <DeptStorage
          deptStorageDetails={deptStorageDetails}
          deptDetails={dept.filter(
            (deptName) => deptName.Course_Code === selectedDept
          )}
        />
      )}
      {selectedDept === "All Course Codes" && dept.length > 0 && (
        <>
          <div className="table-container">
            <div
              className="ag-theme-quartz" // applying the grid theme
              // style={{ maxHeight: 800 }} // the grid will fill the size of the parent container
            >
              <div className="search-container" >
                <label>
                  Search Course Code
                  <input
                    className="search-input"
                    // style={{
                    //   marginLeft: "5px",
                    //   borderRadius: "5px",
                    //   border: "3px",
                    // }}
                    type="text"
                    onInput={onQuickFilterChanged}
                    id="quickFilter"
                    placeholder="Search Course Code"
                  />
                </label>
              </div>
              <AgGridReact
                ref={gridRef}
                rowData={dept}
                columnDefs={colDefs}
                pagination={true}
                paginationPageSize={50}
                domLayout={"autoHeight"}
                tooltipShowDelay={0}
                autoSizeStrategy={autoSizeStrategy}
                rowSelection={"single"}
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default BodyContainer;
